import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetDocumentTagsParams } from "apis/data-contracts";

export const useGetDocumentTagsQuery = (params: GetDocumentTagsParams) => {
  return useSuspenseQuery({
    queryKey: api.document.getDocumentTagsKey(params),
    queryFn: () => api.document.getDocumentTags(params),
    select: (res) => res.data.result,
  });
};
